import React from "react";
import Projects from "./Projects";
import Work from "./Work";
import './Info.css';

const Info = () => {
    return (
        <div className="info-container">
            {/* <Work/> */}
            <Projects />
        </div>
    );
};

export default Info;
